<template>
    <div id="huv-status-hos">
        <section class="huv-status-layout">
            <header class="huv-status-filters">
                <div class="filter">
                    <label class="inputLabel" for="agency-id"> Organization </label>
                    <select id="agency-id" class="form-select pl-1" name="agencies" v-model="selectedAgency">
                        <option v-for="(value, key) of agencyOptions" :value="value.value" :key="key">
                            {{ value.name }}
                        </option>
                    </select>
                    <!-- Uncomment this once BE accept multiple agencies -->
                    <!-- <MultiSelect
                        :dropDownOptions="agencyMultiSelectOptions"
                        labelText="Organizations"
                        :selectedOptions="selectedAgencies"
                        v-on:updateBranches="updateBranchesbyAgency"
                    /> -->
                </div>
                <div class="filter">
                    <label class="inputLabel" for="agency-location-id"> Branch </label>
                    <MultiSelect
                        id="agency-location-id"
                        :dropDownOptions="branchMultiSelectOptions"
                        labelText="Branches"
                        :selectedOptions="selectedBranches"
                        v-on:updateBranches="updateBranches"
                    />
                </div>
                <div class="filter" v-if="selectedAgency.length && selectedBranches.length">
                    <label class="inputLabel" for="team-list"> Team </label>
                    <MultiSelectFilter
                        ref="teamFilter"
                        id="team-list"
                        :on-fetch="getTeamsList"
                        v-model:selected-items="selectedTeams"
                        v-on:selectedItemsUpdated="selectedTeamsUpdated"
                        name="Teams"
                    />
                </div>

                <div class="filter" v-if="selectedAgency.length">
                    <label class="inputLabel" for="taskFilter"> Task </label>
                    <MultiSelectFilter
                        ref="taskFilter"
                        id="taskFilter"
                        :on-fetch="getTaskStatusLean"
                        v-model:selected-items="selectedTask"
                        v-on:selectedItemsUpdated="selectedTaskFilterUpdates"
                        name="taskFilter"
                    />
                </div>
                <div class="filter">
                    <label class="inputLabel" for="taskStatusFilter"> Task Status </label>
                    <MultiSelectFilter
                        ref="taskStatusFilter"
                        id="taskStatusFilter"
                        :on-fetch="getHuvSvfTaskStatusOptions"
                        v-model:selected-items="selectedTaskStatus"
                        v-on:selectedItemsUpdated="selectedTaskStatusFilterUpdates"
                        name="taskStatusFilter"
                    />
                </div>
                <div class="filter me-auto">
                    <label class="inputLabel" for="huvSvfFilter"> HUV/SVF </label>
                    <MultiSelectFilter
                        ref="huvSvfFilter"
                        id="huvSvfFilter"
                        :on-fetch="getHuvSvfStatusOptions"
                        v-model:selected-items="selectedHopeFilter"
                        v-on:selectedItemsUpdated="selectedHopeFilterUpdates"
                        name="huvSvfFilter"
                    />
                </div>

                <div class="form-group h-100 d-flex align-items-end">
                    <button type="button" class="btn btn-primary ms-2 mt-4" @click="exportStatusList()">Export</button>
                </div>
            </header>
            <main class="bg-white rounded mt-2 h-100">
                <PageLayout>
                    <template #content>
                        <div class="h-100 d-flex flex-column mb-3 mt-2">
                            <div class="table-scroll-wrapper">
                                <Pagination
                                    ref="huvSfvStatusPagination"
                                    :pageChanged="pageChangedCallback"
                                    :isLoading="isLoading"
                                    :showPageSizeOptions="true"
                                    classes="pagination-footer pb-2"
                                    :pageSize="pageSize"
                                    v-on:updatePageSizeChanged="updatePageSizeChanged"
                                >
                                    <table class="table table-responsive-md border border-gray">
                                        <thead>
                                            <tr class="bg-table-header">
                                                <!-- <th></th> -->
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="branch"
                                                        class="justify-content-start"
                                                    >
                                                        Branch
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="team"
                                                        class="justify-content-start"
                                                    >
                                                        Team
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="patientFirstName"
                                                        class="justify-content-start"
                                                    >
                                                        First Name
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="patientLastName"
                                                        class="justify-content-start"
                                                    >
                                                        Last Name
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="mrn"
                                                        class="justify-content-start"
                                                    >
                                                        MRN
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="patientStatus"
                                                        class="justify-content-start"
                                                    >
                                                        Patient Status
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="task"
                                                        class="justify-content-start"
                                                    >
                                                        Task
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="hopeType"
                                                        class="justify-content-start"
                                                    >
                                                        HUV/SFV
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="taskStatus"
                                                        class="justify-content-start"
                                                    >
                                                        Task Status
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="visitDate"
                                                        class="justify-content-start"
                                                    >
                                                        Visit Date
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="admissionDate"
                                                        class="justify-content-start"
                                                    >
                                                        Admission Date
                                                    </SortableTh>
                                                </th>
                                                <th>
                                                    <SortableTh
                                                        :sort-by="sortBy"
                                                        v-on:sortByUpdated="sortByUpdated"
                                                        :sort-order="sortOrder"
                                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                                        sort-string="daysRemaining"
                                                        class="justify-content-start"
                                                    >
                                                        Days Remaining
                                                    </SortableTh>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- EMPTY -->
                                            <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                                                <td :colspan="columns">
                                                    <h3>No Tasks Found.</h3>
                                                </td>
                                            </tr>
                                            <!-- ERROR -->
                                            <tr class="table-error" v-if="!isLoading && isError">
                                                <td :colspan="columns">
                                                    <ErrorMessageHandler
                                                        title="Frequency Watch list"
                                                        v-on:try-again="pageReset()"
                                                    />
                                                </td>
                                            </tr>
                                            <!-- LOADING -->
                                            <template v-if="isLoading">
                                                <tr v-for="i of loadingCount" class="table-loading" :key="i">
                                                    <td v-for="i of columns" :key="i">
                                                        <span class="shimmer-loading"></span>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                        <template v-if="!isLoading && !isError && hasData">
                                            <tbody v-for="item in page.Items" :key="item.PatientId">
                                                <HuvSfvStatusReportHosRow
                                                    :statusItem="item"
                                                    :columns="columns"
                                                    :application="application"
                                                    :selectedAgency="selectedAgency"
                                                    :pageReset="pageReset"
                                                />
                                            </tbody>
                                        </template>
                                    </table>
                                </Pagination>
                            </div>
                        </div>
                    </template>
                </PageLayout>
            </main>
        </section>
    </div>
</template>

<style src="./HuvSfvStatusReportHos.scss"></style>
<script src="./HuvSfvStatusReportHos.ts" lang="ts"></script>
